<template>
    <div>
        <div class="main_unit">
            <div class="card wd840 error-card">
                <h5 class="card-header">{{ title }}</h5>
                <div class="card-body">
                    <p>{{ code }}</p><br>
                    <p class="text_white_space_pre_wrap">{{message}}</p><br>
                    <router-link v-if="canBack" class="btn btn-outline-secondary" :to="buttonPath">{{ buttonText }}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ErrorPanel',
        props: {
            title: {
                type: String,
                required: true,
            },
            code: {
                type: String,
                required: true,
            },
            message: {
                type: String,
                required: true,
            },
            buttonPath: {
                type: Object,
                required: true,
            },
            buttonText: {
                type: String,
                required: true,
            },
            canBack: {
                type: Boolean,
                default: true
            }
        }
    }
</script>
